<template>
    <common-chart chart-id="productionOutput" :options="option"></common-chart>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart";

export default {
    name: "ProductionOutput",
    components: {CommonChart},
    // props: {
    //     chartData: Array
    // },
    computed: {
        maxValue() {
            let temp = 0;
            this.chartData.forEach(o => {
                let num = Number.parseInt(o.value);
                if (num > temp) {
                    temp = num;
                }
            })
            return temp;
        },
        labels() {
            let tempList = [];
            this.chartData.forEach(o => tempList.push(o.label));
            return tempList;
        },
        values() {
            let tempList = [];
            this.chartData.forEach(o => tempList.push(o.value));
            return tempList;
        },
        option() {
            let max = this.maxValue;
            return {
                tooltip: {},
                grid: [
                    {
                        top: 10,
                        width: '80%',
                        left: 10,
                        bottom: 10,
                        containLabel: true
                    }
                ],
                xAxis: {
                    type: 'value',
                    max: max,
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        color: '#ddd'
                    },
                    name: '单位：t'
                },
                yAxis: {
                    type: 'category',
                    data: this.labels,
                    axisLabel: {
                        interval: 0,
                        rotate: 30,
                        color: '#ddd'
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [
                    {
                        type: 'bar',
                        stack: 'chart',
                        z: 3,
                        label: {
                            position: 'right',
                            show: true,
                            color: '#eee'
                        },
                        data: this.values
                    },
                    // {
                    //     type: 'bar',
                    //     stack: 'chart',
                    //     silent: true,
                    //     itemStyle: {
                    //         color: '#5a6fc0'
                    //     },
                    //     data: this.values.map(function (value) {
                    //         return max - value;
                    //     })
                    // }
                ]
            };
        }
    },
    data() {
        return {
            chartData: [
                {label: '铬铁粉', value: 15},
                {label: '铬铁粒', value: 10},
                {label: '铬铁(10-50)', value: 50},
                {label: '铬铁(10-100)', value: 80},
                {label: '铬铁(100-250)', value: 100},
            ],
        }
    },
}
</script>

<style scoped>

</style>